import { DownloadUrlDto, ModelEventDto } from '@careapp-group/ng-sdk-v2-new';
import { createAction, props } from '@ngrx/store';

/**
 * Request a download URL.
 *
 * A url will only be requested from the server if we do not
 * already have a valid URL
 */
export const requestDownloadUrl = createAction(
  '[Files][Request] Download URL',
  props<{
    id: string;
  }>()
);

/**
 * Force fetching a URL.
 */
export const requestFetchDownloadUrl = createAction(
  '[Files][Request] Fetch Download URL',
  props<{
    id: string;
  }>()
);
export const responseSuccessDownloadUrl = createAction(
  '[Files][Response][Success] Download URL',
  props<{
    id: string;
    url: DownloadUrlDto;
  }>()
);
export const responseFailDownloadUrl = createAction(
  '[Files][Response][Fail] Download URL',
  props<{
    id: string;
    error: any;
  }>()
);

export const requestLogFileView = createAction(
  `[Files][Request] log file view`,
  props<{
    fileId: string;
  }>()
);
export const successLogFileView = createAction(
  `[Files][Response][Success] log file view`,
  props<{
    fileId: string;
  }>()
);
export const failLogFileView = createAction(
  `[Files][Response][Fail] log file view`,
  props<{
    fileId: string;
    error: any;
  }>()
);

export const requestFileHistory = createAction(
  `[Files][Request] retrieve file history`,
  props<{
    fileId: string;
  }>()
);
export const successFileHistory = createAction(
  `[Files][Response][Success] retrieve file history`,
  props<{
    history: ModelEventDto[];
    fileId: string;
  }>()
);
export const failFileHistory = createAction(
  `[Files][Response][Fail] retrieve file history`,
  props<{
    fileId: string;
    error: any;
  }>()
);
